import { useState } from "react";
import { Modal } from "react-bootstrap";
import { ArrowLeft, X } from "lucide-react";
import EPRBox from "../../../../Company/EPR";
import "./index.css";

export default function ImportDataModal({
  open,
  onClose,
  onChooseKlimakompasset,
  businessId,
}) {
  const [view, setView] = useState("choose"); // choose | economic

  const close = () => {
    setView("choose");
    onClose?.();
  };

  const goEconomic = () => setView("economic");

  return (
    <Modal show={!!open} onHide={close} centered size="lg" dialogClassName="impDataModal">
      <Modal.Body className="impDataModal__body">
        <button type="button" className="impDataModal__close" onClick={close} aria-label="Close">
          <X size={18} />
        </button>
        {view === "choose" ? (
          <>
            <div className="impDataModal__kicker">Import</div>
            <div className="impDataModal__title">Import data</div>

            <div className="impDataModal__grid">
              <button type="button" className="impDataModal__card" onClick={goEconomic}>
                <div className="impDataModal__cardTitle">e-conomic</div>
                <div className="impDataModal__cardSub">ERP connection</div>
              </button>
              <button
                type="button"
                className="impDataModal__card"
                onClick={() => onChooseKlimakompasset?.()}
              >
                <div className="impDataModal__cardTitle">Klimakompasset</div>
                <div className="impDataModal__cardSub">Upload Excel</div>
              </button>
            </div>
          </>
        ) : (
          <>
            <button
              type="button"
              className="impDataModal__back"
              onClick={() => setView("choose")}
            >
              <ArrowLeft size={16} /> Back
            </button>
            <div className="impDataModal__kicker">ERP</div>
            <div className="impDataModal__title">e-conomic import</div>
            <div className="impDataModal__embed">
              <EPRBox businessId={businessId} />
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}

